import styled from "styled-components";

export const StyledWrapperDSDatagrid = styled.div`
  padding: 16px;
  .em-ds-data-grid .em-ds-data-grid-body__row {
    border-bottom: 0.07692rem solid #ebedf0;
  }
`;
